import React from "react";
import "./AllPastTransaction.scss";
import SubPageHeader from "../../component/SubPageHeader/SubPageHeader";
import PastTransaction from "../../component/PortfolioComponents/PastTransaction";
import fetchQuery from "relay-runtime/lib/query/fetchQuery";
import environment from "../../Environment";
import PortfolioPastTransactionQuery from "../../queries/PortfolioPastTransactionQuery";
import Loading from "../../component/Loading";
import {assetUrl} from "../../serviceApi";

const SearchIcon = assetUrl+"images/search-icon-white.svg";


class AllPastTransaction extends React.Component{
    state = {
        search_text:"",
        pastTransaction:[],
        loading:false
    }

    componentDidMount() {
        this.getPastTransactions();
    }

    getPastTransactions = () => {
        let variable = {};
        this.updateLoading(true);
        fetchQuery(environment, PortfolioPastTransactionQuery,variable)
            .toPromise()
            .then(response => {
                this.updateLoading(false);
                if (response.pastTransactionOrderWise !== null && response.pastTransactionOrderWise.edges.length > 0) {
                    this.setState({
                        pastTransaction:response.pastTransactionOrderWise.edges
                    });
                }
            }, err => {
                console.log(err);
                this.updateLoading(false);
                this.setState({
                    pastTransaction:[]
                });
            });
    }

    hangleSearchInput = (e) => {
        this.setState({
            search_text:e.target.value
        },()=>{
            if(e.target.value === ""){
                this.getPastTransactions();
            }
        });
    }
    updateLoading = (action) => {

        this.setState({
            loading:action
        })
    }
    searchPastTransaction = () => {

        let variable = {
            searchPolitician:this.state.search_text
        };

        this.updateLoading(true);
        fetchQuery(environment, PortfolioPastTransactionQuery, variable)
            .toPromise()
            .then(response => {

                this.updateLoading(false);
                if (response.pastTransactionOrderWise !== null  && response.pastTransactionOrderWise.edges.length > 0) {
                    this.setState({
                        pastTransaction: response.pastTransactionOrderWise.edges
                    });
                } else {
                    this.setState({
                        pastTransaction: []
                    });
                }
            }, err => {
                console.log(err);
                this.updateLoading(false);
                this.setState({
                    pastTransaction: []
                });
            });
    }


    render() {

        const {pastTransaction} = this.state;
        return(
           <Loading loading={this.state.loading}>
               <div className={"all-past-transaction-component"}>
                   {/*<MDBContainer>*/}
                       <SubPageHeader title={"Past Transactions"} show_action={true}/>
                   {/*</MDBContainer>*/}
                   <div className={"past-transaction-main"}>
                       <div className={"search-section"}>
                           <div className="input-group">
                               <input type="text" className="form-control"
                                      placeholder="Search" value={this.state.search_text}
                                      onChange={(e)=>this.hangleSearchInput(e)}
                               />
                               <div className="input-group-append">
                                   <button className="btn search-btn" type="button" onClick={this.searchPastTransaction}>
	                                   <img src={SearchIcon} alt={"SearchIcon"}/>
                                   </button>
                               </div>
                           </div>
                       </div>
                       <div>
                           <PastTransaction pastTransactionData={pastTransaction}/>
                       </div>
                   </div>

               </div>
           </Loading>
        );
    }
}

export default AllPastTransaction;